import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import ErrorMessage from '../ErrorMessage';

function DatePicker({
  name,
  value,
  onChange,
  variant,
  label,
  views,
  minDate,
  maxDate,
  disabled,
  errors,
  required,
}) {
  const handleOnchange = (date) => {
    onChange({ target: { name, value: date } });
  };

  return (
    <KeyboardDatePicker
      autoOk
      fullWidth
      disabled={disabled}
      required={required}
      views={views}
      margin='normal'
      variant={variant}
      inputVariant={variant}
      label={label}
      format={views ? undefined : 'dd/MM/yyyy'}
      minDate={minDate || undefined}
      maxDate={maxDate || undefined}
      value={value}
      InputAdornmentProps={{ position: 'start' }}
      onChange={handleOnchange}
      cancelLabel='Відмінити'
      error={errors && errors.length > 0}
      helperText={<ErrorMessage errors={errors} />}
    />
  );
}

export default DatePicker;
